import { ENGLISH_ONLY_STANDALONE_PAGES } from '../data/translationScopePolicy.js';
import { sourceRevision } from './translationAssurance.js';

export function buildEnglishOnlyStandalonePageRows() {
  return ENGLISH_ONLY_STANDALONE_PAGES.map((page) => {
    const id = 'externalStaticHtml:' + page.slug;
    const sourceText = page.title + ' — standalone page at /' + page.path.replace(/^public\//, '');
    return {
      id, namespace: 'externalStaticHtml', path: page.path,
      contentArea: 'core_ui', sourceText, originalText: '',
      sourceRevision: sourceRevision(id, sourceText),
      publicationTarget: 'excluded',
      exclusionCode: 'intentionally_english_only',
      exclusionReason: 'Deliberately English-only standalone HTML page (product owner decision). No professional translation required for this release.',
      provenance: 'standalone static HTML (outside patient React app)',
    };
  });
}
